
import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AddDevoteeComponent } from "./admin/components/add-devotee/add-devotee.component";
import { DevoteeListComponent } from "./admin/components/devotee-list/devotee-list.component";
import { DevoteeAddressPrintComponent } from "./admin/components/devotee-address-print/devotee-address-print.component";
import { DevoteeAddressPrint2Component } from "./admin/components/devotee-address-print2/devotee-address-print2.component";
import { AdminHomeComponent } from "./admin/components/admin-home/admin-home.component";
import { NotificationComponent } from "./admin/notification/notification.component";
import { DevoteeProfileComponent } from './devotee/devotee-profile/devotee-profile.component';
import { DevoteeHomeComponent } from './devotee/devotee-home/devotee-home.component';
import { DevoteeLoginComponent } from './devotee/devotee-login/devotee-login.component';
import { DevoteeRegistationComponent } from './devotee/devotee-registation/devotee-registation.component';
import { DevoteeDashboardComponent } from './devotee/devotee-dashboard/devotee-dashboard.component';
import { ComingSoonComponent } from './devotee/coming-soon/coming-soon.component';
import { PujaPrasadComponent } from './prasad-order/puja-prasad/puja-prasad.component';
import { PujaPrasadOrderComponent } from './prasad-order/puja-prasad-order/puja-prasad-order.component';
import { GallaryComponent } from './devotee-module/components/gallary/gallary.component';
import { DasaraFestivalComponent } from './devotee/dasara-festival/dasara-festival.component';
import { AdminPujaPrasadOrderComponent } from './admin/components/admin-puja-prasad-order/admin-puja-prasad-order.component';
import { PrasadOrderListComponent } from './admin/components/prasad-order-list/prasad-order-list.component';
import { TodaysPujaComponent } from './admin/components/todays-puja/todays-puja.component';
import { AdminLoginComponent } from './admin/components/admin-login/admin-login.component';
import { PoDispatchComponent } from './admin/components/po-dispatch/po-dispatch.component';
import { PoByPaymentModeComponent } from './admin/components/po-by-payment-mode/po-by-payment-mode.component';

import { SharedService } from "./shared/shared.service";
import { SerialkeyComponent } from "./devotee/serialkey/serialkey.component";
import { AdminDevoteeAddressPrintComponent } from "./admin/components/admin-devotee-address-print/admin-devotee-address-print.component";
import { PrasadOrderReportComponent } from "./admin/components/prasad-order-report/prasad-order-report.component";
import { PostOfficeReportComponent } from "./admin/components/post-office-report/post-office-report.component";
import { AboutUsComponent } from "./devotee/about-us/about-us.component";
import { ContactUsComponent } from "./devotee/contact-us/contact-us.component";
import { PrivacyPolicyComponent } from "./devotee/privacy-policy/privacy-policy.component";
import { TermsConditionsComponent } from "./devotee/terms-conditions/terms-conditions.component";
import { MobileAppRedirectComponent } from "./devotee/mobile-app-redirect/mobile-app-redirect.component";
import { ShippingPolicyComponent } from "./devotee/shipping-policy/shipping-policy.component";
import { MyPujaPrasadOrderComponent } from "./prasad-order/my-puja-prasad-order/my-puja-prasad-order.component";

const adminRoutes: Routes = [
    {
        path: 'adminhome',
        component: AdminHomeComponent
    },
    {
        path: 'add-devotee',
        component: AddDevoteeComponent
    },
    {
        path: 'edit-devotee/:id',
        component: AddDevoteeComponent
    },
    {
        path: 'devotee-list',
        component: DevoteeListComponent
    },
    {
        path: 'devoteeaddressprint',
        component: AdminDevoteeAddressPrintComponent
    },
    {
        path: 'devoteeaddressprint2',
        component: DevoteeAddressPrint2Component
    },
    {
        path: 'notification',
        component: NotificationComponent
    },
    {
        path: 'pujaprasadorder/:devoteeId',
        component: AdminPujaPrasadOrderComponent
    },
    {
        path: 'pujaprasadorder/:devoteeId/:poNo',
        component: AdminPujaPrasadOrderComponent
    },
    {
        path: 'pujaprasadorderlist',
        component: PrasadOrderListComponent
    },
    {
        path: 'pujaprasadorderlist/:mobileNo',
        component: PrasadOrderListComponent
    },
    {
        path: 'pobypaymentmode',
        component: PoByPaymentModeComponent
    },
    {
        path: 'todayspuja',
        component: TodaysPujaComponent
    },
    {
        path: 'podispatch',
        component: PoDispatchComponent
    },
    {
        path: 'prasadorderreport',
        component: PrasadOrderReportComponent
    },
    {
        path: 'postofficereport',
        component: PostOfficeReportComponent
    },
    {
        path: 'login',
        component: AdminLoginComponent
    },
    {
        path: '',
        redirectTo: 'devotee-list',
        pathMatch: 'full'
    }
]

const devoteeRoutes: Routes = [
    {
        path: 'dashboard',
        component: DevoteeDashboardComponent
    },
    {
        path: 'new-registation',
        component: DevoteeRegistationComponent
    },
    {
        path: 'devoteehome',
        component: DevoteeHomeComponent
    },    
    {
        path: 'devoteeprofile',
        component: DevoteeProfileComponent
    },
    {
        path: 'pujaprasadseva',
        component: PujaPrasadComponent
    },
    {
        path: 'gallary',
        component: GallaryComponent
    },
    {
        path: 'pujaprasadorder',
        component: PujaPrasadOrderComponent
    },
    {
        path: 'mypujaprasadorder/:msg/:paymentOrderId',
        component: MyPujaPrasadOrderComponent
    },
    {
        path: 'mypujaprasadorder/:msg',
        component: MyPujaPrasadOrderComponent
    },
    {
        path: 'dasarafestival',
        component: DasaraFestivalComponent
    },
    {
        path: 'comingsoon',
        component: ComingSoonComponent
    },
    {
        path: 'about-us',
        component: AboutUsComponent
    },
    {
        path: 'contact-us',
        component: ContactUsComponent
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'termsconditions',
        component: TermsConditionsComponent
    },
    {
        path: 'shipping-policy',
        component: ShippingPolicyComponent
    },
    {
        path: 'mobileapp',
        component: MobileAppRedirectComponent
    },
    {
        path: 'serialkey',
        component: SerialkeyComponent
    },
    {
        path: 'login',
        component: DevoteeLoginComponent
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    }
]







export const RouteModule: ModuleWithProviders = SharedService.showAdminApp
    ? RouterModule.forRoot(adminRoutes, { useHash: true })
    : RouterModule.forRoot(devoteeRoutes, { useHash: true });


// WEBPACK FOOTER //
// ./src/app/app.route.ts